export enum CloudAppV2RelationType {
    CloudUser = 'user',
    SecurityGroup = 'group',
    AllCollectionUsers = 'all'
}
